const teamsByLeague = {
  AJHL: [
    "BONNYVILLE",
    "BROOKS",
    "CALGARY CANUCKS",
    "CALGARY MUSTANGS",
    "CAMROSE",
    "CANMORE",
    "FORT MCMURRAY",
    "GRANDE PRAIRIE",
    "LLOYDMINSTER",
    "OKOTOKS",
    "OLDS",
    "SHERWOOD PARK",
    "SPRUCE GROVE",
    "WHITECOURT",
  ],
  ALLSVENSKAN: [
    "AIK",
    "ALMTUNA",
    "BJORKLOVEN",
    "BOFORS",
    "DJURGARDEN",
    "KARLSKOGA",
    "LEKSAND",
    "MALMO",
    "MODO",
    "MORA",
    "MORA IK",
    "OSKARSHAMN",
    "ROGLE",
    "SODERTALJE",
    "TIMRA",
    "VASTERAS",
  ],
  AUSTRIA: ["KLAGENFURT", "SALZBURG"],
  "AUSTRIA-2": ["RB HOCKEY JUNIORS"],
  "AUSTRIA-JR": ["EC SALZBURG 2"],
  BCHL: [
    "ALBERNI VALLEY",
    "BURNABY",
    "CHILLIWACK",
    "COQUITLAM",
    "COWICHAN VALLEY",
    "LANGLEY",
    "MERRITT",
    "NANAIMO",
    "PENTICTON",
    "POWELL RIVER",
    "PRINCE GEORGE",
    "SALMON ARM",
    "SURREY",
    "TRAIL",
    "VERNON",
    "VICTORIA",
    "WENATCHEE",
    "WEST KELOWNA",
    "WESTSIDE",
  ],
  BELARUS: ["GOMEL", "KERAMIN", "YUNOST MINSK", "JUNOST MINSK"],
  "BELARUS-JR": ["DYNAMO JR."],
  "BELARUS-JR.2": ["JUNOST MINSK 2"],
  CAHS: ["ST. ANDREWS COLLEGE", "STANSTEAD COLLEGE"],
  CCHL: [
    "BROCKVILLE",
    "CARLETON PLACE",
    "HAMILTON",
    "KEMPTVILLE",
    "NEPEAN",
    "NEWMARKET",
    "ORANGEVILLE",
    "OTTAWA",
    "SMITHS FALLS",
    "ST. MICHAELS",
  ],
  CJHL: [
    "CUMBERLAND",
    "PEMBROKE",
    "BROCKVILLE",
    "NEPEAN",
    "SMITH FALLS",
    "SMITHS FALLS",
  ],
  CZECH: [
    "PLZEN",
    "BRNO",
    "CHOMUTOV",
    "HR. KRALOVE",
    "JIHLAVA",
    "LIBEREC",
    "OLOMOUC",
    "PARDUBICE",
    "SLAVIA",
    "SPARTA",
    "TRINEC",
    "VITKOVICE",
    "ZLIN",
  ],
  "CZECH-2": [
    "BENATKY N. J.",
    "C. BUDEJOVICE",
    "CHOMUTOV",
    "FRYDEK-MISTEK",
    "HAVIROV",
    "JIHLAVA",
    "KADAN",
    "KLADNO",
    "LITOMERICE",
    "ML. BOLESLAV",
    "SOKOLOV",
    "TREBIC",
    "USTI N. L.",
  ],
  "CZECH-U18": [
    "KARLOVY VARY U18",
    "LIBEREC U18",
    "ML. BOLESLAV U18",
    "RB HOCKEY AKADEMIA",
    "SLAVIA U18",
    "TRINEC U18",
    "VSETIN U18",
  ],
  "CZECH-U20": [
    "PLZEN",
    "BRNO JR",
    "BRNO JR.",
    "C. BUDEJOVICE JR.",
    "CHOMUTOV JR.",
    "HR. KRALOVE JR.",
    "JIHLAVA JR.",
    "KARLOVY VARY JR.",
    "KLADNO JR.",
    "LIBEREC JR.",
    "LITVINOV JR.",
    "ML. BOLESLAV JR.",
    "OLOMOUC JR.",
    "PARDUBICE JR.",
    "PLZEN JR.",
    "RB HOCKEY AKADEMIA",
    "SLAVIA JR.",
    "SPARTA JR.",
    "TRINEC JR.",
    "USTI N. L. JR.",
    "VITKOVICE JR.",
    "VSETIN JR.",
    "ZLIN JR.",
  ],
  "CZECH-U20.2": ["VSETIN JR."],
  DEL: [
    "EHC MUNCHEN",
    "EISBAREN BERLIN",
    "HAMBURG FREEZ.",
    "KOLN",
    "KREFELD",
    "MANNHEIM",
    "MUNCHEN",
  ],
  DENMARK: ["AALBORG", "ESBJERG", "FREDERIKSHAVN", "HERNING", "RODOVRE"],
  "DENMARK-2": ["RODOVRE SIK", "VOJENS"],
  "DIVISION I": [
    "OSTERSUND",
    "SKARE",
    "SKOVDE",
    "VASTERAS",
    "VISBY/ROMA",
    "FARJESTAD JR.",
  ],
  DNL: [
    "MANNHEIM",
    "HEILBRONN",
    "EISBAREN JR.",
    "DUSSELDORF JR.",
    "KREFELD JR.",
    "MANNHEIM JR.",
    "BAD TOLZ JR.",
    "EISBAREN BERLIN JR.",
    "KOLN JR.",
    "LANDSHUT JR.",
    "ROSENHEIM JR.",
  ],
  EIHL: ["SHEFFIELD"],
  FRANCE: ["GRENOBLE"],
  "GERMANY-2": [
    "DUSSELDORF",
    "LANDSHUT CANN.",
    "DRESDEN",
    "HEILBRONN",
    "KAUFBEUREN",
    "ROSENHEIM",
  ],
  "GERMANY-3": ["EISBAREN BERLIN", "BAD TOLZ", "FASS BERLIN"],
  GHL: ["ST. CATHARINES"],
  GOJHL: ["LEAMINGTON"],
  "J18 ELIT": [
    "FARJESTAD JR.",
    "TROJA-LJUNGBY JR.",
    "BRYNAS U18",
    "AIK U18",
    "DJURGARDEN U18",
    "FARJESTAD U18",
    "FROLUNDA U18",
    "LEKSAND U18",
    "LINKOPING U18",
    "NACKA U18",
    "SKELLEFTEA U18",
    "SODERTALJE U18",
  ],
  "J20 ELIT": ["ALMTUNA JR."],
  "U20 SM-sarja": [
    "ASSAT JR.",
    "BLUES JR.",
    "HIFK JR.",
    "HPK JR.",
    "ILVES JR.",
    "JOKERIT JR.",
    "JUKURIT JR.",
    "JYP JR.",
    "K-ESPOO JR.",
    "KALPA JR.",
    "KARPAT JR.",
    "LUKKO JR.",
    "PELICANS JR.",
    "SAIPA JR.",
    "SPORT JR.",
    "TAPPARA JR.",
    "TPS JR.",
    "TUTO JR.",
  ],
  "JR B SM-sarja": ["K-VANTAA JR.", "JOKERIT U18"],
  KAZAKHSTAN: ["TEMIRTAU"],
  KHL: [
    "AK BARS KAZAN",
    "BARYS NUR-SULTAN",
    "CSKA",
    "JOKERIT",
    "METALLURG",
    "SIBIR NOVOSIBIRSK",
    "TORPEDO",
    "ASTANA",
    "BRATISLAVA",
    "CHELYABINSK",
    "CHEREPOVETS",
    "DYNAMO MINSK",
    "DYNAMO MOSCOW",
    "KAZAN",
    "KHANTY-MANSIYSK",
    "LEV POPRAD",
    "MAGNITOGORSK",
    "MVD BALASHIKHA",
    "MVD BALASHIKHA 2",
    "MYTISCHI",
    "NIZHNEKAMSK",
    "NIZHNY NOVGOROD",
    "NOVOKUZNETSK",
    "NOVOSIBIRSK",
    "OMSK",
    "PODOLSK",
    "RIGA",
    "SPARTAK",
    "ST. PETERSBURG",
    "TOGLIATTI",
    "UFA",
    "YAROSLAVL",
    "YEKATERINBURG",
  ],
  LATVIA: ["RIGA"],
  LIIGA: [
    "ASSAT",
    "BLUES",
    "HIFK",
    "HPK",
    "ILVES",
    "JOKERIT",
    "JUKURIT",
    "JYP",
    "KALPA",
    "KARPAT",
    "KOOKOO",
    "LUKKO",
    "PELICANS",
    "SAIPA",
    "SPORT",
    "TAPPARA",
    "TPS",
  ],
  MESTIS: [
    "ESPOO",
    "HERMES",
    "JOKIPOJAT",
    "JYP 2",
    "K-VANTAA",
    "KOOVEE",
    "LEKI",
    "PELIITAT",
    "TUTO",
  ],
  MHL: [
    "BELYE MEDVEDI",
    "DYNAMO",
    "HK MVD",
    "KAPITAN STUPINO",
    "KRASNAYA ARMIYA",
    "LOKO YAROSLAVL",
    "MAMONTY YUGRY",
    "METALLURG MAISKIY",
    "MHC SPARTAK",
    "MHK DYNAMO",
    "MVD",
    "NOVOSIBIRSK",
    "RUSSKIE VITYAZI",
    "SKA 1946",
    "SKA ST.P",
    "SKA-VARYAGI",
    "SPUTNIK ALMETIEVSK",
    "STALNYE LISY",
    "TEAM RUSSIA U18",
    "TOLPAR UFA",
    "VITYAZI CHEKHOV",
    "YAROSLAVL",
    "ASTANA 2",
    "CHEKHOV 2",
    "CHELYABINSK 2",
    "CHEREPOVETS 2",
    "CSKA 2",
    "DONETSK JR.",
    "DYNAMO MOSCOW 2",
    "DYNAMO ST. PETERSBURG 2",
    "EC SALZBURG 2",
    "IRBIS KAZAN",
    "KARLOVY VARY JR.",
    "KAZAN 2",
    "KHABAROVSK 2",
    "KHANTY-MANSIYSK 2",
    "KRYLJA SOVETOV 2",
    "LEV POPRAD 2",
    "LVI ST. PETERSBURG 2",
    "LVY ST. PETERSBURG 2",
    "MAGNITOGORSK 2",
    "MVD BALASHIKHA 2",
    "MYTISCHI 2",
    "NIZHNEKAMSK 2",
    "NIZHNY NOVGOROD 2",
    "NOVOKUZNETSK 2",
    "NOVOSIBIRSK 2",
    "OMSK 2",
    "RIGA 2",
    "SKA ST. PETERSBURG 2",
    "SPARTAK 2",
    "ST. PETERSBURG 2",
    "STUPINO 2",
    "TOGLIATTI 2",
    "TYUMEN 2",
    "UFA 2",
    "VOSKRESENSK 2",
    "YAROSLAVL 2",
    "YEKATERINBURG 2",
  ],
  MIDGET: [
    "CALGARY NS",
    "TEAM SOUTH WEST",
    "DALLAS STARS AAA",
    "RUSSELL STOVER",
    "PHILADELPHIA JR. B",
    "BELLE TIRE U18",
    "BOSTON ADV. AAA",
    "BOSTON ADVANTAGE U18",
    "HONEYBAKED U18",
    "NORTH JERSEY AVALANCHE U18",
    "OHIO BLUE JACKETS",
    "OHIO BLUE JACKETS U18",
    "PITTSBURGH VIPER STARS",
    "SELECTS ACADEMY U18",
    "TEAM MARYLAND AAA",
    "ST. LOUIS JR. BLUES",
  ],
  MJHL: [
    "PORTAGE",
    "STEINBACH",
    "WAYWAYSEECAPPO",
    "WINNIPEG BLUES",
    "WINNIPEG SOUTH",
  ],
  MWEHL: ["LITTLE CAESARS", "VICTORY HONDA MIDGET"],
  MWJHL: ["LISTOWEL"],
  NAHL: [
    "ABERDEEN",
    "AUSTIN",
    "CORPUS CHRISTI",
    "FAIRBANKS",
    "JANESVILLE",
    "JOHNSTOWN",
    "LONE STAR",
    "MINNESOTA MAGICIANS",
    "MINNESOTA WILDERNESS",
    "MN MAGICIANS",
    "ODESSA",
    "SHREVEPORT",
    "SPRINGFIELD",
    "TOPEKA",
    "TRAVERSE CITY",
    "WENATCHEE",
    "WICHITA FALLS",
    "WILKES-BARRE",
  ],
  NCAA: [
    "MICHIGAN",
    "MICHIGAN STATE",
    "MINNESOTA",
    "NOTRE DAME",
    "OHIO STATE",
    "PENN STATE",
    "U OF MICHIGAN",
    "U OF MINNESOTA",
    "U OF WISCONSIN",
    "WISCONSIN",
    "FERRIS STATE U.",
    "LAKE SUPERIOR",
    "MIAMI U.",
    "MIAMI UNIVERSITY",
    "NORTHERN MICH.",
    "U OF NOTRE DAME",
    "U. OF MICHIGAN",
    "WESTERN MICH.",
    "WESTERN MICHIGAN",
    "BROWN U.",
    "CLARKSON U.",
    "CORNELL U.",
    "HARVARD",
    "HARVARD U.",
    "QUINNIPIAC",
    "RENSSELAER",
    "RPI",
    "ST. LAWRENCE",
    "UNION COLLEGE",
    "BOSTON COLLEGE",
    "BOSTON UNIVERSITY",
    "MERRIMACK",
    "NEW HAMPSHIRE",
    "NORTHEASTERN",
    "PROVIDENCE",
    "U OF CONNECTICUT",
    "U OF MAINE",
    "U. MASS-LOWELL",
    "U. MASS.",
    "U. OF VERMONT",
    "UCONN",
    "UMASS",
    "UMASS LOWELL",
    "MIAMI",
    "MINNESOTA-DULUTH",
    "ST. CLOUD STATE",
    "U MINN-DULUTH",
    "U OF DENVER",
    "U. OF DENVER",
    "BOWLING GREEN",
    "BOWNING GREEN",
    "MICHIGAN TECH",
    "MINNESOTA STATE",
    "NEBRASKA-OMAHA",
    "NORTH DAKOTA",
    "U. MINN-DULUTH",
    "U. OF WISCONSIN",
  ],
  NLA: [
    "AMBRI",
    "BERN",
    "BIEL",
    "DAVOS",
    "GENEVE",
    "KLOTEN",
    "LANGNAU",
    "LUGANO",
    "ZURICH",
  ],
  NLB: [
    "BASEL",
    "CHAUX-DE-FONDS",
    "CHUR",
    "GCK ZURICH",
    "LAUSANNE",
    "VISP",
    "ZUG ACADEMY",
  ],
  NMHL: ["LOKO-YUNIOR YAROSLAV"],
  NOJHL: ["SOO THUNDERBIRDS"],
  NORWAY: ["LORENSKOG", "SARPSBORG", "STAVANGER", "STJERNEN", "VALERENGA"],
  NTDP: ["USA U-17", "USA U-18"],
  OHL: [
    "BARRIE",
    "BELLEVILLE",
    "BRAMPTON",
    "ERIE",
    "FLINT",
    "GUELPH",
    "HAMILTON",
    "KINGSTON",
    "KITCHENER",
    "LONDON",
    "MISSISSAUGA",
    "NIAGARA",
    "NORTH BAY",
    "OSHAWA",
    "OTTAWA",
    "OWEN SOUND",
    "PETERBOROUGH",
    "PLYMOUTH",
    "SAGINAW",
    "SARNIA",
    "SAULT ST. MARIE",
    "SAULT STE. MARIE",
    "SUDBURY",
    "WINDSOR",
  ],
  OJHL: [
    "KINGSTON",
    "OAKVILLE",
    "VAUGHAN",
    "AURORA",
    "BUFFALO JR. SABRES",
    "BURLINGTON",
    "COBOURG",
    "GEORGETOWN",
    "NORTH YORK",
    "PICKERING",
    "ST. MICHAELS",
    "STOUFFVILLE",
    "TORONTO JC",
    "TORONTO LAKESHORE",
    "WELLINGTON",
    "WHITBY",
    "ST. MICHAEL'S",
  ],
  QMJHL: [
    "ACADIE-BATHURST",
    "BAIE COMEAU",
    "BAIE-COMEAU",
    "BLAINVILLE-BOISBRIAND",
    "CAPE BRETON",
    "CHARLOTTETOWN",
    "CHICOUTIMI",
    "DRUMMONDVILLE",
    "GATINEAU",
    "HALIFAX",
    "LEWISTON",
    "MONCTON",
    "MONTREAL",
    "PEI",
    "QUEBEC",
    "RIMOUSKI",
    "ROUYN-NORANDA",
    "SAINT JOHN",
    "SHAWINIGAN",
    "SHERBROOKE",
    "ST. JOHN'S",
    "VAL D'OR",
    "VAL-D'OR",
    "VICTORIAVILLE",
  ],
  "RUSSIA-3": [
    "CHEKHOV 2",
    "CHEREPOVETS 2",
    "CSKA 2",
    "DYNAMO MOSCOW 2",
    "KAZAN 2",
    "KRYLJA SOVETOV 2",
    "MAGNITOGORSK 2",
    "MYTISCHI 2",
    "NIZHNEKAMSK 2",
    "NIZHNY NOVGOROD 2",
    "OMSK 2",
    "PENZA 2",
    "SPARTAK 2",
    "ST. PETERSBURG 2",
    "UFA 2",
    "VOSKRESENSK 2",
    "YAROSLAVL 2",
  ],
  SHL: [
    "LULEA",
    "OREBRO",
    "AIK",
    "BRYNAS",
    "DJURGARDEN",
    "FARJESTAD",
    "FROLUNDA",
    "HV 71",
    "LINKOPING",
    "MALMO",
    "MODO",
    "OSTERSUNDS",
    "ROGLE",
    "SKELLEFTEA",
    "SODERTALJE",
    "TIMRA",
    "VAXJO",
  ],
  SIJHL: ["THUNDER BAY"],
  SJHL: ["HUMBOLDT", "NOTRE DAME"],
  SLOVAKIA: [
    "B. BYSTRICA",
    "BRATISLAVA",
    "DETVA",
    "HC BANSKA BYSTRICA",
    "KOSICE",
    "L. MIKULAS",
    "MARTIN",
    "NITRA",
    "POPRAD",
    "SLOVAKIA U20",
    "TRENCIN",
    "ZVOLEN",
  ],
  "SLOVAKIA-2": ["PRIEVIDZA", "SLOVAKIA U18", "ZILINA"],
  "SLOVAKIA-U20": [
    "B. BYSTRICA JR.",
    "BRATISLAVA JR.",
    "KOSICE JR.",
    "L. MIKULAS JR.",
    "MARTIN JR.",
    "NITRA JR.",
    "SKALICA JR.",
    "TRENCIN JR.",
    "TRNAVA JR.",
    "ZILINA JR.",
    "POPRAD JR.",
    "SLOVAKIA U18",
    "SPIS. N. VES JR.",
  ],
  "J20 Nationell": [
    "STORHAMAR JR.",
    "MALMO JR.",
    "OSTERSUNDS JR.",
    "DJURGARDEN JR.",
    "FROLUNDA JR.",
    "LINKOPING JR.",
    "OREBRO JR.",
    "AIK JR.",
    "BRYNAS JR.",
    "HV71 JR.",
    "LULEA JR.",
    "ROGLE JR.",
    "BJORKLOVEN JR.",
    "FARJESTAD JR.",
    "HUDDINGE JR.",
    "HV 71 JR.",
    "KARLSKRONA JR.",
    "LEKSAND JR.",
    "MODO JR.",
    "MORA JR.",
    "SKELLEFTEA JR.",
    "SODERTALJE JR.",
    "TIMRA JR.",
    "TINGSRYD JR.",
    "VASTERAS JR.",
    "VAXJO JR.",
  ],
  "U20 ELIT": [
    "AMBRI JR.",
    "BERN JR.",
    "BIEL JR.",
    "DAVOS JR.",
    "FRIBOURG JR.",
    "GCK ZURICH JR.",
    "GENEVE JR.",
    "KLOTEN JR.",
    "LANGNAU JR.",
    "LAUSANNE JR.",
    "LUGANO JR.",
    "RAPPERSWIL JR.",
    "ZUG JR.",
    "ZURICH JR.",
  ],
  "US-TIER3": [
    "NY BOBCATS",
    "WALPOLE",
    "ISLANDERS",
    "JR. HUSKIES",
    "JR. MONARCHS",
    "JUNIOR BRUINS",
    "NEW JERSEY",
    "PHILADELPHIA",
    "SOUTH SHORE",
    "SYRACUSE",
    "VALLEY",
    "SOUTH SHORE KINGS",
    "SYRACUSE STARS",
    "PORTLAND JR. PIRATES",
    "SPRINGFIELD PICS",
  ],
  USHL: [
    "BLOOMINGTON",
    "CEDAR RAPIDS",
    "CENTRAL ILLINOIS",
    "CHICAGO",
    "DES MOINES",
    "DUBUQUE",
    "FARGO",
    "GREEN BAY",
    "INDIANA",
    "LINCOLN",
    "MADISON",
    "MUSKEGON",
    "USA U-18",
    "OHIO",
    "OMAHA",
    "SIOUX CITY",
    "SIOUX FALLS",
    "TRI-CITY",
    "WATERLOO",
    "YOUNGSTOWN",
  ],
  USHS: [
    "AVON OLD FARMS",
    "BRUNSWICK PREP",
    "CANTERBURY",
    "CHOATE-ROSEMARY",
    "HOTCHKISS",
    "KENT",
    "LOOMIS-CHAFFEE",
    "SALISBURY",
    "SOUTH KENT",
    "TAFT SCHOOL",
    "THE GUNNERY",
    "WESTMINSTER",
    "CULVER ACADEMY",
    "ANDOVER",
    "AUSTIN PREP",
    "BELMONT HILL",
    "BERKSHIRE",
    "BOSTON COLLEGE H.S.",
    "BROOKS SCHOOL",
    "CATHOLIC MEMORIAL",
    "CUSHING ACADEMY",
    "DEERFIELD",
    "DEXTER",
    "GOVERNOR'S ACADEMY",
    "GROTON",
    "LAWRENCE ACADEMY",
    "MALDEN CATHOLIC",
    "MILTON ACADEMY",
    "NOBLE & GREENOUGH",
    "NOBLES",
    "READING",
    "RIVERS ACADEMY",
    "ST. JOHN'S PREP",
    "ST. MARK'S",
    "ST. SEBASTIAN",
    "THAYER ACADEMY",
    "WALTHAM",
    "WILLISTON-NORTHAMPTON",
    "WINCHESTER",
    "BERWICK ACADEMY",
    "BROTHER RICE HS",
    "CRANBROOK KINGSWOOD",
    "ANOKA",
    "BENILDE-ST. MARGARET'S",
    "BLAINE",
    "BLAKE",
    "BLOOMINGTON-JEFF.",
    "BRAINERD",
    "BRECK HIGH",
    "BURNSVILLE",
    "CENTENNIAL",
    "CHASKA",
    "CLOQUET",
    "CRETIN-DERHAM",
    "DETROIT LAKES",
    "DULUTH EAST",
    "DULUTH MARSHALL",
    "EAGAN",
    "EASTVIEW HIGH",
    "EDEN PRAIRIE",
    "EDEN PRARIE",
    "EDINA",
    "ELK RIVER",
    "GRAND RAPIDS",
    "GREENWAY",
    "HERMANTOWN",
    "HIBBING",
    "HILL-MURRAY",
    "HOLY ANGELS",
    "HOLY FAMILY",
    "INTERNATIONAL FALLS",
    "LAKEVILLE NORTH",
    "LAKEVILLE SOUTH",
    "LITTLE FALLS",
    "MAHTOMEDI",
    "MAPLE GROVE",
    "MINNETONKA",
    "MOORHEAD",
    "NEW PRAGUE",
    "PRIOR LAKE",
    "ROSEAU",
    "ROSEAU HIGH",
    "ROSEMOUNT",
    "SHATTUCK-ST.MARYS",
    "ST. CLOUD CATHEDRAL",
    "ST. PAUL JOHNSON",
    "ST. THOMAS",
    "STILLWATER",
    "TARTAN",
    "THIEF RIVER FALLS",
    "TOTINO GRACE",
    "VIRGINIA",
    "WARROAD",
    "WAYZATA",
    "WOODBURY",
    "EXETER",
    "HOLDERNESS",
    "KIMBALL UNION",
    "NEW HAMPTON",
    "PROCTOR ACADEMY",
    "DELBARTON",
    "LAWRENCEVILLE",
    "ALBANY",
    "MILLBROOK",
    "NORTHWOOD",
    "ST. GEORGE'S",
    "ASHWAUBENON",
    "EAU CLAIRE MEMORIAL",
    "MOSINEE",
    "WAUPACA",
    "WAUSAU",
    "WAUSAU WEST",
    "WEST SALEM",
    "BLOOMINGTON JEFF.",
    "NOTRE DAME",
    "ST SEBASTIAN",
    "ST. THOMAS ACADEMY",
  ],
  VHL: [
    "BALASHIKHA",
    "BARS KAZAN",
    "CHEKHOV",
    "CHELMET",
    "KRYLJA SOVETOV",
    "LIPETSK",
    "MECHEL",
    "NEVA ST. PETERSBURG",
    "PENZA",
    "PERM",
    "RYAZAN",
    "SAMARA",
    "TOGLIATTI",
    "UST-KAMENOGORSK",
    "CSK VVS SAMARA",
    "KAZAN",
  ],
  WHL: [
    "BRANDON",
    "CALGARY",
    "CHILLIWACK",
    "EDMONTON",
    "EVERETT",
    "KAMLOOPS",
    "KELOWNA",
    "KOOTENAY",
    "LETHBRIDGE",
    "MEDICINE HAT",
    "MOOSE JAW",
    "PORTLAND",
    "PRINCE ALBERT",
    "PRINCE GEORGE",
    "RED DEER",
    "REGINA",
    "SASKATOON",
    "SEATTLE",
    "SPOKANE",
    "SWIFT CURRENT",
    "TRI-CITY",
    "VANCOUVER",
    "VICTORIA",
    "WINNIPEG",
  ],
};

export default teamsByLeague;
